import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { TreeNode } from '../../components';
// Components
import { AdminHome } from './adminHome';
// Menus
import { AdminAdminAddressState, AdminAdminAddressCity } from './administrators/addressing';
import { AdminEventEventCategory, AdminEventEventType } from './administrators/eventSetup';
import { AdminEventManagement } from './events/eventManagement';
import { AdminEventDetailsManagement } from './events/eventDetailsManagement';

const AdminStack = createStackNavigator();

export const menus: TreeNode[] = [
  {
    id: 0,
    label: 'Home',
    screen: 'admin-home',
  },
  {
    id: 1,
    label: 'Administrator Setup',
    children: [
      {
        id: 3,
        label: 'Addressing Setup',
        children: [
          {
            id: 5,
            screen: 'admin-addressing-state',
            label: 'State Setup',
          },
          {
            id: 6,
            screen: 'admin-addressing-city',
            label: 'City Setup',
          },
        ],
      },
      {
        id: 4,
        label: 'Event Setup',
        children: [
          {
            id: 7,
            screen: 'admin-event-type',
            label: 'Event Type',
          },
          {
            id: 8,
            screen: 'admin-event-category',
            label: 'Event Category',
          },
        ],
      },
    ],
  },
  {
    id: 2,
    screen: 'event-setup',
    label: 'Event Setup',
    children: [
      {
        id: 9,
        screen: 'event-management',
        label: 'Event Management',
      },
    ],
  },
];

// Required
export const AdminWebLinksConfig = {
  'admin-home': 'admin-home',
  'admin-addressing-state': 'admin-addressing-state',
  'admin-addressing-city': 'admin-addressing-city',
  'admin-event-type': 'admin-event-type',
  'admin-event-category': 'admin-event-category',
  'event-management': 'event-management',
};

export const AdminPortalRoutes = () => (
  <AdminStack.Navigator
    screenOptions={{
      headerShown: false,
    }}
    initialRouteName="admin-home"
  >
    <AdminStack.Screen name="admin-home" component={AdminHome} options={{ title: 'Event Management' }} />
    <AdminStack.Screen
      name="admin-addressing-state"
      component={AdminAdminAddressState}
      options={{ title: 'Event Management - State Setup' }}
    />
    <AdminStack.Screen
      name="admin-addressing-city"
      component={AdminAdminAddressCity}
      options={{ title: 'Event Management - City Setup' }}
    />
    <AdminStack.Screen
      name="admin-event-category"
      component={AdminEventEventCategory}
      options={{ title: 'Event Management - Event Category Setup' }}
    />
    <AdminStack.Screen
      name="admin-event-type"
      component={AdminEventEventType}
      options={{ title: 'Event Management - Event Type Setup' }}
    />
    <AdminStack.Screen
      name="event-management"
      component={AdminEventManagement}
      options={{ title: 'Event Management - Event Setup' }}
    />
    <AdminStack.Screen
      name="event-details-management"
      component={AdminEventDetailsManagement}
      options={{ title: 'Event Details Management - Event Setup' }}
    />
  </AdminStack.Navigator>
);
/*const AppNavigator = createStackNavigator({
  Home: {
    screen: HomeScreen,
    navigationOptions: { title: 'Home' },
  },
  Parent: {
    screen: ParentScreen,
    navigationOptions: { title: 'Parent' },
  },
  Child: {
    screen: ChildScreen,
    navigationOptions: { title: 'Child' },
  },
});
*/
